import withAemIntegration from "../../withAemIntegration";
import loadable from "../../utils/loadable";

const Component = loadable(() =>
    import("@lexus.com/ui/dist/_nextgen/components/TitleFeature")
);

const ComponentEditConfig = {
    emptyLabel: "Title Feature",
    isEmpty: function (props) {
        return !props || !props.title || props.title.trim().length < 1;
    },
};

const transformData = (props) => ({
      component: "TitleFeature",
      props: {
        ...props,
        subTitle: props?.subtitle,
        variant: props?.variation,
        // TODO: see if this is still needed with the ComponentContainer updates
        backgroundColor:
          props?.componentProperties?.componentDesign?.backgroundColor,
        backgroundOpacity:
        props?.componentProperties?.componentDesign?.backgroundOpacity,
        backgroundMedia:
          props?.componentProperties?.componentDesign?.backgroundMedia,
        contentWidth: props?.componentProperties?.componentDesign?.contentWidth,
      },
    });

const TitleFeature = (props) => {
    const data = transformData(props);
    return <Component {...data?.props} />;
};

export default withAemIntegration("lexus/components/content/title-feature")(
    TitleFeature,
    ComponentEditConfig
);
